import i18next from 'i18next';

i18next.addResources('es', 'drawer', {
  close: 'Cerrar',
  open: 'Abrir'
});

i18next.addResources('en', 'drawer', {
  close: 'Close',
  open: 'Open'
});

i18next.addResources('pt', 'drawer', {
  close: 'Fechar',
  open: 'Abrir'
});
